import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { Button } from "@faire/web--source/slate/Button";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { Spacer, getSpacing } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { trackSignupSignupModalSellAsBrandClick } from "@faire/web-api--source/events/signup/click/signupModalSellAsBrand";
import brands from "@faire/web-api--source/routes/brands";
import React from "react";
import styled from "styled-components";
export var SellOnFaire = function() {
    return /*#__PURE__*/ _jsxs(Column, {
        children: [
            /*#__PURE__*/ _jsx(Spacer, {
                height: "2x"
            }),
            /*#__PURE__*/ _jsx(SellOnFaireSection, {
                children: /*#__PURE__*/ _jsx(Typography, {
                    variant: "paragraphSansRegular",
                    align: "center",
                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "52k4CM",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Are you a brand? "
                            },
                            {
                                type: 8,
                                value: "LinkFormatting",
                                children: [
                                    {
                                        type: 0,
                                        value: "Sign up to sell on Faire"
                                    }
                                ]
                            }
                        ],
                        values: {
                            LinkFormatting: LinkFormatting
                        }
                    })
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "3x"
            })
        ]
    });
};
var SellOnFaireSection = styled(Row).attrs({
    justify: "center",
    align: "center"
}).withConfig({
    componentId: "sc-2eae9ed6-0"
})([
    "padding:",
    ";background-color:",
    ";border-radius:4px;"
], getSpacing("1x", "2x"), Core.surface.subdued);
var recordBrandClick = function() {
    trackSignupSignupModalSellAsBrandClick();
};
var LinkFormatting = function(chunks) {
    return /*#__PURE__*/ _jsx(Button, {
        variant: "tertiary",
        linkTo: brands(),
        onClick: recordBrandClick,
        target: "_blank",
        children: chunks
    });
};
